import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahClaimItems } from '~constants/api';

import { PaginatedRequest, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { DashboardClaimItemsResponse, DashboardColumnSpecsResponse } from '~support-at-home/models/dashboard';

export const dashboardClaimItemsApi = createApi({
  reducerPath: 'dashboardClaimItemsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahClaimItems }),
  tagTypes: ['dashboard-claim-items'],
  endpoints: (builder) => ({
    getDashboardClaimItems: builder.query<DashboardClaimItemsResponse, PaginatedRequest>({
      query: (params) => ({
        url: '/dashboard',
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'dashboard-claim-items', id: 'LIST' }],
      transformResponse: (payload) => unwrap<DashboardClaimItemsResponse>(payload),
    }),
    getDashboardClaimItemsSpecs: builder.query<DashboardColumnSpecsResponse, void>({
      query: () => ({
        url: '/dashboard',
        method: 'GET',
        params: { specs: true },
      }),
      providesTags: [{ type: 'dashboard-claim-items', id: 'SPECS' }],
      transformResponse: (payload) => unwrap<DashboardColumnSpecsResponse>(payload),
    }),
  }),
});

export const { useGetDashboardClaimItemsQuery, useGetDashboardClaimItemsSpecsQuery } = dashboardClaimItemsApi;
